import { useEffect, useState } from 'react'

function usePageConfig({ listener = 'window-config-loaded', checkIfAvailable = true } = {}) {
  const [pageConfig, setPageConfig] = useState(() =>
    typeof window !== 'undefined' && checkIfAvailable ? window.pageConfig : undefined
  )

  useEffect(() => {
    function setAndCheckPageConfig() {
      setPageConfig(window.pageConfig)
    }

    // Check if pageConfig is already available
    if (window.pageConfig && !pageConfig && checkIfAvailable) {
      setAndCheckPageConfig()
    }

    window.addEventListener(listener, setAndCheckPageConfig)

    return () => {
      window.removeEventListener(listener, setAndCheckPageConfig)
    }
  }, [])

  return pageConfig
}

export default usePageConfig
